import { Skeleton } from "antd"
import React from "react"
import "./style.scss"
import styled from "styled-components"
import Column from "src/components/column/column.component"

const SkeletonCardWrapper = styled(Column as any)`
  width: ${props => props.width};
  border-radius: 6px;
  justify-content: center;
  display: flex;
  align-items: flex-start;
  padding: ${props => props.pd};
`
const SkeletonCardImageWrapper = styled(Column as any)`
  width: 100%;
  margin-bottom: 5px;
`

interface Props {
  imgWidth?: string
  imgHeight?: string
  rows: number
  width?: string
  isImage?: boolean
  avatar?: boolean
  pd?: string
}

const SkeletonComponent = (props: Props) => {
  const {
    imgWidth = "100%",
    imgHeight,
    rows = 4,
    width = "24rem",
    isImage = false,
    avatar = false,
    pd = "2rem"
  } = props
  return (
    <>
      <SkeletonCardWrapper width={width} pd={pd}>
        <>
          {isImage && (
            <SkeletonCardImageWrapper>
              <Skeleton.Image style={{ width: imgWidth, height: imgHeight, borderRadius: 6 }} />
            </SkeletonCardImageWrapper>
          )}
          <Skeleton paragraph={{ rows }} avatar={avatar} active />
        </>
      </SkeletonCardWrapper>
    </>
  )
}

export default SkeletonComponent
